export enum AccountSubdomain {
  MSC = 'msc',
  POSTAL = 'postal',
  LPC = 'lpc',
  DHTX = 'dhtx',
  PEPSICO = 'pepsico',
  ICG = 'icg',
  E2E = 'e2e',
}
